import { FormattedMessage } from "react-intl";

import {
    SignupBackgroundLayout,
    TwcOverlayTemplate
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    FreeForTenUsersText,
    Headings,
    SubHeading,
    WelcomeBackHeading,
    WelcomeBackText
} from "../../components";

export const ExistingUser = () => {
    const twcSignupOverlayEnrolled = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );

    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    const content = (
        <>
            {team26VisualUpdates ? (
                <Headings
                    main={<WelcomeBackText />}
                    sub={<FreeForTenUsersText />}
                />
            ) : (
                <>
                    <WelcomeBackHeading />
                    <SubHeading>
                        <FormattedMessage
                            id="signup.teamworkCollection.subHeading"
                            defaultMessage="It’s free for up to 10 users - no credit card needed."
                        />
                    </SubHeading>
                </>
            )}
            <SiteActivation />
        </>
    );

    if (twcSignupOverlayEnrolled) {
        return <TwcOverlayTemplate size="sm">{content}</TwcOverlayTemplate>;
    }

    return (
        <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
            {content}
        </SignupBackgroundLayout>
    );
};
